import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import type { LaunchMediaArticle } from "../types/launch";

const mediaArticlesQueryKey = (mediaId: string | undefined) =>
  ["launch-media", "medias", mediaId, "articles"] as const;

export function useMediaArticles(mediaId: string | undefined) {
  return useQuery({
    queryKey: mediaArticlesQueryKey(mediaId),
    queryFn: async () => {
      const response = await httpClient.mediaMgmt.get<{
        articles: LaunchMediaArticle[];
      }>(`/medias/${encodeURIComponent(mediaId!)}/articles`);
      return response.articles ?? [];
    },
    enabled: !!mediaId,
  });
}
